import { useEffect } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import InvoiceExtractionHintsPanel, {
    type InvoiceExtractionHintsPanelProps,
} from '../../components/invoice/InvoiceExtractionHintsPanel';

export interface InvoiceExtractionHintsModalProps extends InvoiceExtractionHintsPanelProps {
    isOpen: boolean;
}

/**
 * In-panel modal that covers the invoice detail right half (Main / Key Reconciliations)
 * without unmounting it. The invoice image on the left stays visible.
 */
export default function InvoiceExtractionHintsModal({
    isOpen,
    onBack,
    ...panelProps
}: InvoiceExtractionHintsModalProps) {
    useEffect(() => {
        if (!isOpen) return undefined;
        const onKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') onBack();
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [isOpen, onBack]);

    if (!isOpen) return null;

    return (
        <Box
            position="absolute"
            inset={0}
            zIndex={20}
            bg="blackAlpha.500"
            p={8}
            display="flex"
            onClick={onBack}
        >
            <Flex
                role="dialog"
                aria-modal="true"
                aria-labelledby="invoice-extraction-hints-title"
                direction="column"
                bg="white"
                w="full"
                h="full"
                minH={0}
                overflow="hidden"
                borderRadius="lg"
                boxShadow="xl"
                px={6}
                py={4}
                onClick={(event) => event.stopPropagation()}
            >
                <InvoiceExtractionHintsPanel onBack={onBack} {...panelProps} />
            </Flex>
        </Box>
    );
}
